import React from 'react'

export const NoRoute = () => {
  return (
    <div>you have a hit a wrong Route </div>
  )
}
